import firebase from 'firebase/app';
import 'firebase/auth'

async function signOut() {
  try {
    await firebase.auth().signOut();
  } catch ( error ) {
    console.log( 'Error signing out.', error );
  }
}

async function sendEmailVerification() {
  try {
    await firebase.auth().currentUser.sendEmailVerification();
    console.info( 'sent verification email' )
    return true
  } catch ( e ) {
    console.error( 'error sending verification email:', e )
    return false
  }
}

export {
  signOut,
  sendEmailVerification,
}

export default {
  signOut,
  sendEmailVerification,
}
